import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, ShoppingBagIcon, StarIcon } from 'lucide-react';
interface BrandingSpecialist {
  id: string;
  name: string;
  title: string;
  specialties: string[];
  rating: number;
  reviewCount: number;
  imageUrl: string;
  available: boolean;
  priceRange: string;
}
const BookMerchBranding = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All');
  const specialists: BrandingSpecialist[] = [{
    id: '1',
    name: 'Lisa Park',
    title: 'Brand Identity Designer',
    specialties: ['Author Branding', 'Series Branding', 'Marketing Materials'],
    rating: 4.8,
    reviewCount: 89,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
    priceRange: '$500-2000'
  }, {
    id: '2',
    name: 'Chris Morgan',
    title: 'Merchandise Brand Specialist',
    specialties: ['Book Merchandise', 'Brand Strategy', 'Visual Identity'],
    rating: 4.7,
    reviewCount: 64,
    imageUrl: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
    priceRange: '$400-1500'
  }];
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-8558" data-mp="2qg3otvl4se4x">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8559" data-mp="2qeir5x3isf2u">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-8560" data-mp="2lgqzn46seuz6">
          <ShoppingBagIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" data-id="element-8561" data-mp="2zh1pc3wd23ir" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-8562" data-mp="2zexndri0vel4">
            Book Merchandise & Branding
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-8563" data-mp="1530qvk4q3ij7">
            Connect with branding specialists who can help create cohesive
            merchandise and brand identity for your books
          </p>
        </div>
        {/* Search and Filter */}
        <div className="mb-8 flex flex-col sm:flex-row gap-4" data-id="element-8564" data-mp="307qipwruao4x">
          <div className="relative flex-1" data-id="element-8565" data-mp="354gvob8cl3m4">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-8566" data-mp="357csfw8glm8z" />
            <input type="text" placeholder="Search by name or specialty..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-8567" data-mp="3a6prdfclujrx" />
          </div>
        </div>
        {/* Specialists Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-8568" data-mp="1oa3p1zaout6">
          {specialists.map(specialist => <div key={specialist.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-8569" data-mp="6oo0fnvg4ibw">
              <img src={specialist.imageUrl} alt={specialist.name} className="w-full h-48 object-cover" data-id="element-8570" data-mp="aphrur83kf9j" />
              <div className="p-6" data-id="element-8571" data-mp="1r4m6phq1io7e">
                <div className="flex justify-between items-start mb-2" data-id="element-8572" data-mp="1r7ru8sj0ti10">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-8573" data-mp="1m744ea6j378d">
                    {specialist.name}
                  </h3>
                  <div className="flex items-center" data-id="element-8574" data-mp="1h9u582tc7h7c">
                    <StarIcon className="h-5 w-5 text-yellow-400" data-id="element-8575" data-mp="2eu84c0qrkvda" />
                    <span className="ml-1 text-sm text-gray-600" data-id="element-8576" data-mp="29wetuvifhf77">
                      {specialist.rating}
                    </span>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mb-4" data-id="element-8577" data-mp="2533q538wxeji">{specialist.title}</p>
                <div className="mb-4" data-id="element-8578" data-mp="2063jaq48o7rc">
                  <div className="flex flex-wrap gap-2" data-id="element-8579" data-mp="2xm98nimb5du3">
                    {specialist.specialties.map(specialty => <span key={specialty} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-8580" data-mp="2stzko84r6nug">
                        {specialty}
                      </span>)}
                  </div>
                </div>
                <div className="flex items-center justify-between text-sm mb-4" data-id="element-8581" data-mp="23gei22r5qdf3">
                  <span className={specialist.available ? 'text-green-600' : 'text-red-600'} data-id="element-8582" data-mp="28epqqa5puhvq">
                    {specialist.available ? 'Available for Work' : 'Currently Unavailable'}
                  </span>
                  <span className="text-gray-600" data-id="element-8583" data-mp="2mblb2yrf3vr3">{specialist.priceRange}</span>
                </div>
                <div className="flex gap-2" data-id="element-8584" data-mp="2rafuo2x7loc9">
                  <button className="flex-1 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-8585" data-mp="3f23ho9rcof99">
                    Contact
                  </button>
                  <Link to={`/creative/book-merch-branding/${specialist.id}`} className="flex-1 border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50 transition-colors text-center" data-id="element-8586" data-mp="18dkvqnexlm15">
                    View Portfolio
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default BookMerchBranding;